export default class DebugInfoUtil {
  public static generateContentfulEntryLink(spaceId: string, entryId: string) {
    return `https://app.contentful.com/spaces/${spaceId}/entries/${entryId}`;
  }

  public static generatePIMLink(prd: string, version?: string) {
    return `https://pim.products.cimpress.io/merchant/products/${prd}${
      version ? `/versions/${version}` : ""
    }`;
  }
}
